import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './Components/Header';
import Home from './Pages/Home';
import Services from './Pages/ServicesPage';
import Marketing from './Pages/services/Marketing';
import Hiring from './Pages/services/Hiring';
import Graphic from './Pages/services/Graphic';
import WebDev from './Pages/services/WebDev';
import Work from './Pages/Work';
import About from './Pages/About';
import Footer from './Components/Footer';
import PrivacyPolicy from './Pages/Privacy';
import ContactUs from './Pages/ContactUs';
import Terms from './Pages/Terms';
function App() {

  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/services' element={<Services />} />
          <Route path="/services/marketing" element={<Marketing />} />
          <Route path="/services/hiring" element={<Hiring />} />
          <Route path="/services/graphic-design" element={<Graphic />} />
          <Route path="/services/software-development" element={<WebDev />} />
          <Route path='/work' element={<Work />} />
          <Route path='/about' element={<About />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-of-service' element={<Terms />} />
          <Route path='/contact' element={<ContactUs />} />
        </Routes>
        <Footer/>
      </BrowserRouter>
    </>
  );
}

export default App;